import React from 'react';
import { connect } from 'react-redux';
import { Box, HorizontalScroll } from '@drone-js/core';
import { DetailPageTabsProps, mapDispatchToProps, mapStateToProps, shiftFocusByIndexAndHref, TabId } from 'component/page/detail/DetailPageTabs/DetailPageTabs.selectors';
import { Tab } from 'component/page/detail/DetailPageTabs/TabItem';
import { useExperimentIsB } from 'component/common/Experiment/Experiment';
import { ExperimentId } from 'core/type/ExperimentId';
import { BorderType, BorderwidthType } from '@drone-js/theme';

const DetailPageTabsComponent: React.FC<DetailPageTabsProps> = (props) => {
    const [active, setActive] = React.useState(0);

    const shouldShowBottomBorderWithCorrectBorderColor = useExperimentIsB(ExperimentId.AWL_779);
    const borderWidth: BorderwidthType[] = shouldShowBottomBorderWithCorrectBorderColor ? ['0', '0', '1', '0'] : ['1', '0', '0', '0'];
    const borderColor: BorderType = shouldShowBottomBorderWithCorrectBorderColor ? 'base.default' : 'base.inverted';

    const getIndexFromSelectedTab = React.useCallback(() => {
        const index = props.tabs.findIndex((x) => x.href === props.selectedTab);
        return index === -1 ? 0 : index;
    }, [props.selectedTab, props.tabs]);

    React.useEffect(() => {
        setActive(getIndexFromSelectedTab());
    }, [props.selectedTab, getIndexFromSelectedTab]);

    if (!props.isSuccess) {
        return <Box py="24" />;
    }

    const onTabChanged = (index: number) => {
        const tab = props.tabs[index];
        props.onTabChanged(tab);
        setActive(index);
        shiftFocusByIndexAndHref(index, tab.href);
    };

    const getTabId = (id: string, index: number) => `${id}-tab-${index + 1}`;

    const tabItems = props.tabs.map((x, i) => {
        return (
            <Tab
                label={x.title}
                id={getTabId(TabId, i)}
                key={getTabId(TabId, i)}
                aria-label={x.title}
                onClick={() => onTabChanged(i)}
                isActive={active === i}
                aria-current={active === i ? 'true' : 'false'}
                width="content-fit"
                size="s"
            />
        );
    });

    return (
        <HorizontalScroll
            id={TabId}
            aria-label={props.cms[342164]}
            data-testid={TabId}
            nextLabel={props.cms[130706]}
            previousLabel={props.cms[130765]}
            width="fit-content"
            whiteSpace="nowrap"
            onActiveChange={onTabChanged}
            active={active}
            borderWidth={borderWidth}
            borderStyle="solid"
            borderColor={borderColor}
            behavior="item"
            restrictFocus={true}
            role="navigation"
        >
            {tabItems}
        </HorizontalScroll>
    );
};
DetailPageTabsComponent.displayName = 'DetailPageTabsComponent';

export default connect(mapStateToProps, mapDispatchToProps)(DetailPageTabsComponent);
